import React, { useState } from "react";
import style from "./index.module.scss";
import Statics from "../Statics";
import Search from "../Search";
import StuList from "./components/StuList";
import { QuestionnaireInfo, StuInfo } from "../../../../../../service/question";

interface ExerciseStuListProps {
    questionnaireId: number;
    data: StuInfo[];
    onChange: (value: string) => void;
    onChangeType: (value: string) => void;
    joinInCount: number;
    noJoinInCount: number;
    pageData: QuestionnaireInfo | null;
}

export default function ExerciseStuList({
    questionnaireId,
    data,
    joinInCount,
    noJoinInCount,
    onChange,
    pageData,
    onChangeType
}: ExerciseStuListProps) {
    const [current, setCurrent] = useState("all");

    function onClick(val: string) {
        setCurrent(val);
        onChangeType(val);
    }

    return (
        <div className={style.root}>
            <Statics
                committed={joinInCount || 0}
                uncommitted={noJoinInCount || 0}
                current={current}
                onChange={onClick}
            />
            <Search onChange={onChange} className={style.search} />
            {data && (
                <StuList
                    pageData={pageData}
                    questionnaireId={questionnaireId}
                    data={data}
                />
            )}
        </div>
    );
}
